export default {
  title: 'Customers',
  subTitle: 'Lorem ipsum dolor',
  totalPages: '{{offset}}-{{totalPages}} of {{total}}',
  archivingReasonTitle: 'Specify reason for archiving',
  archivingReasonDescription: 'Please provide a reason for archiving the selected record(s). You can restore '
        + 'them anytime.',
  archiveDetails: 'Archived record details',
  editInformation: 'Edit Information',
  addNewCustomer: 'Add New Customer',
  editCustomer: 'Edit Customer',
  fields: {
    action: 'Action',
    customerName: 'Customer Name',
    customerCode: 'Customer Code',
    upstreamTier: 'Upstream Tier',
    uniqueIdentifier: 'Customer System Unique Identifier',
    profitCentreId: 'Profit Centre ID',
    valueChain: 'Value Chain Position',
    ownership: 'Ownership',
    equityShareholding: 'Equity Shareholding %',
    financialControl: 'Financial Control %',
    physicalOrLogical: 'Logical / Physical',
    dateOpened: 'Date Customer Record Opened',
    dateClosed: 'Date Customer Record Closed',
    priorityRating: 'Priority Rating',
    industry: 'Industry (NACE)',
    sector: 'Sector (NACE)',
    expectedGrowth: 'Expected Growth',
    totalRevenue: '% of Total Revenue',
    actualRevenue: 'Actual Revenue',
    country: 'Country of Operation / Incorporation',
    state: 'State / Region / County',
    post: 'Post Code',
    town: 'City',
    street: 'Street',
    building: 'Building Name / Number',
    coordinates: 'Coordinates',
    actions: 'Actions',
    expectedGrowthDecline: 'Expected Growth / Decline % (in next 12 months)',
    startDate: 'FY Start Date',
    endDate: 'FY End Date',
    startDateIsRequired: 'Start Date is required if any financial field is filled',
    euTaxonomyActivityCode: 'EU Taxonomy Activity Code',
    profitCentre: 'Profit Centre',
    sourceVCMId: 'Value Chain ID',
  },
  selections: {
    general: 'General',
    details: 'Details',
    financials: 'Financials',
    address: 'Address',
  },
};
